import { createSelector } from '@reduxjs/toolkit';
import WorkspaceAPI from '../WorkspaceAPI';
import {
  WorkspaceIdRequestAPI,
  WorkspaceAPIResponse,
} from '../WorkspaceAPI.model';
import _ from 'lodash';
import { RootState } from '../../store.model';
import { QueryStatus } from '@reduxjs/toolkit/query';
export interface ItemsWorkspaceRequestWrapped
  extends Partial<WorkspaceIdRequestAPI>,
    Partial<WorkspaceAPIResponse> {
  requests: WorkspaceIdRequestAPI[];
  lastRequest?: WorkspaceIdRequestAPI;
  workspace?: WorkspaceAPIResponse;
}

/** At the moment we only support one workspace */
export const getMyWorkspaceSelector = createSelector(
  [WorkspaceAPI.endpoints.getMyWorkspaces.select(undefined)],
  (workspacesResponse) =>
    _.last(
      _.sortBy(
        workspacesResponse.data,
        (workspace) => workspace.parentId === null
      )
    )
);

export const getAllWorkspaceByIdSelector = createSelector(
  [(state: RootState) => state[WorkspaceAPI.reducerPath]?.queries],
  (queries) =>
    Object.entries(queries)
      .filter(([key, query]) => {
        return (
          query?.endpointName === 'getWorkspaceById' &&
          query?.status === QueryStatus.fulfilled &&
          query?.data
        );
      })
      .map(([key, query]) => {
        return query?.data as WorkspaceAPIResponse;
      })
);

export const getCurrentWorkspaceSelector = (marketId?: string) =>
  createSelector(
    [
      WorkspaceAPI.endpoints.getMyWorkspaces.select(undefined),
      WorkspaceAPI.endpoints.getWorkspaceById.select(marketId ?? ''),
    ],
    (workspacesResponse, workspaceByIdResponse) => {
      if (marketId && workspaceByIdResponse?.data) {
        return workspaceByIdResponse.data;
      }

      if (marketId) {
        const found = workspacesResponse.data?.find((w) => w.id === marketId);
        if (found) return found;
      }

      return _.last(
        _.sortBy(workspacesResponse.data, (w) => w.parentId === null)
      );
    }
  );
